export default __webpack_public_path__ + "images/8M.21965a5.png";